// anonymous user id stored in localStorage; lets us save personal mnemonics + progress
let _cached = null;

export function getUserId() {
  if (_cached) return _cached;
  if (typeof window === "undefined") return "anon";
  try {
    let id = window.localStorage.getItem("kanji_uid");
    if (!id) {
      id = "u_" + Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
      window.localStorage.setItem("kanji_uid", id);
    }
    _cached = id;
    return id;
  } catch {
    return "anon";
  }
}
